/**
 * esta función sirve para resumir la respuesta de los estados.
 * El string resultado es translated con mortgageRequestProgressStates_#####
 */
const constants = require('./mortgageRequestStates');

const getProgressState = (state) => {
    let progresState = 'none';
    switch (state) {
        case constants.SIMULACION:
        case constants.RESULTADO_SIMULACION:
        case constants.PRE_APROBACION:
        case constants.PRE_APROBADO:
        case constants.SOLIC_PRESTAMO:
            progresState = 'none';
            break;
        case constants.APORTAR_DOC:
        case constants.AUT_CIRBE:
        case constants.AUT_CIRBE_CO:
        case constants.WAIT_CIRBE_COT:
            progresState = 'preApproved';
            break;
        case constants.DATOS_VIV:
        case constants.TRAMITAR_NS:
        case constants.WAIT_NS:
        case constants.PROBLEMA_NS:
        case constants.PEND_TASACION:
        case constants.TRAMITAR_TAS:
        case constants.WAIT_DICTAMEN:
        case constants.ANALISIS_TAS:
            progresState = 'preApprovedPendingAppraisal';
            break;
        case constants.APROBADO_RIESGOS:
        case constants.PROV_FONDOS:
        case constants.ESPERA_DOC_FIRMA:
        case constants.ESPERA_ACTA_NOTARIO:
        case constants.GESTION_FECHA_FIRMA:
        case constants.PEND_MMPP:
        case constants.PEND_SALDO:
        case constants.PEND_FIRMA:
        case constants.APERTURA_CUENTA:
            progresState = 'approved';
            break;
        case constants.FIRMADO:
            progresState = 'granted';
            break;
        case constants.ERROR_BUREAUS:
        case constants.MODEL_CORRECT:
            progresState = 'denied';
            break;
    }
    return progresState;
}

module.exports = {
    getProgressState
}
